import { render, staticRenderFns } from "./fila-da-creche.vue?vue&type=template&id=7922543e&scoped=true&"
import script from "./fila-da-creche.vue?vue&type=script&lang=js&"
export * from "./fila-da-creche.vue?vue&type=script&lang=js&"
import style0 from "./fila-da-creche.vue?vue&type=style&index=0&id=7922543e&lang=scss&scoped=true&"
import style1 from "./fila-da-creche.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922543e",
  null
  
)

export default component.exports